import {useEffect} from 'react';

import {SERVICE_NAME} from 'common/constants';
import {FilterXSS} from 'xss';

interface UseDocumentTitle {
    (title?: string): void;
}

const filterHtml = new FilterXSS({
    whiteList: {}, // empty, means filter out all tags
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script'], // the script tag is a special case, we need to filter out its content
});

const useDocumentTitle: UseDocumentTitle = (title) => {
    useEffect(() => {
        let currTitle = SERVICE_NAME;
        if (title) {
            currTitle = `${filterHtml.process(title)} — ${SERVICE_NAME}`;
        }
        document.title = currTitle;
        return () => {
            document.title = SERVICE_NAME;
        };
    }, [title]);
};

export default useDocumentTitle;
